// extracted by mini-css-extract-plugin
module.exports = {"content":"FactoryResetInstructions-module__content___1aq0B"};